module.exports = __webpack_public_path__ + "img/productRobot_23.26c190bc.png";